import React from "react";
import { useParams } from "react-router-dom";
import "../styles/SingleSectorPage.css";

// Tüm sektör resimlerini manuel olarak import edelim
import commerce1 from "../assets/sectorspage/commerce/commerce (1).jpg";
import commerce2 from "../assets/sectorspage/commerce/commerce (2).jpg";
import commerce3 from "../assets/sectorspage/commerce/commerce (3).jpg";
import commerce4 from "../assets/sectorspage/commerce/commerce (4).jpg";
import commerce5 from "../assets/sectorspage/commerce/commerce (5).jpg";
import commerce6 from "../assets/sectorspage/commerce/commerce (6).jpg";
import commerce7 from "../assets/sectorspage/commerce/commerce (7).jpg";
import commerce8 from "../assets/sectorspage/commerce/commerce (8).jpg";
import commerce9 from "../assets/sectorspage/commerce/commerce (9).jpg";

import academy1 from "../assets/sectorspage/academy/academy (1).jpg";
import academy2 from "../assets/sectorspage/academy/academy (2).jpg"; 
import academy3 from "../assets/sectorspage/academy/academy (3).jpg";
import academy4 from "../assets/sectorspage/academy/academy (4).jpg";
import academy5 from "../assets/sectorspage/academy/academy (5).jpg";
import academy6 from "../assets/sectorspage/academy/academy (6).jpg";
import academy7 from "../assets/sectorspage/academy/academy (7).jpg";
import academy8 from "../assets/sectorspage/academy/academy (8).jpg";
import academy9 from "../assets/sectorspage/academy/academy (9).jpg";

import consultancy1 from "../assets/sectorspage/consultancy/consultancy (1).jpg";
import consultancy2 from "../assets/sectorspage/consultancy/consultancy (2).jpg";
import consultancy3 from "../assets/sectorspage/consultancy/consultancy (3).jpg";
import consultancy4 from "../assets/sectorspage/consultancy/consultancy (4).jpg";
import consultancy5 from "../assets/sectorspage/consultancy/consultancy (5).jpg";
import consultancy6 from "../assets/sectorspage/consultancy/consultancy (6).jpg";
import consultancy7 from "../assets/sectorspage/consultancy/consultancy (7).jpg";
import consultancy8 from "../assets/sectorspage/consultancy/consultancy (8).jpg";
import consultancy9 from "../assets/sectorspage/consultancy/consultancy (9).jpg";

import economy1 from "../assets/sectorspage/economy/economy (1).jpg";
import economy2 from "../assets/sectorspage/economy/economy (1).png";
import economy3 from "../assets/sectorspage/economy/economy (2).png";
import economy4 from "../assets/sectorspage/economy/economy (5).jpg";
import economy5 from "../assets/sectorspage/economy/economy (7).jpg";
import economy6 from "../assets/sectorspage/economy/economy (11).jpg";
import economy7 from "../assets/sectorspage/economy/economy (12).jpg";
import economy8 from "../assets/sectorspage/economy/economy (13).jpg";
import economy9 from "../assets/sectorspage/economy/economy (14).jpg";

import industry1 from "../assets/sectorspage/industry/industry (1).jpg";
import industry2 from "../assets/sectorspage/industry/industry (2).jpg";
import industry3 from "../assets/sectorspage/industry/industry (3).jpg";
import industry4 from "../assets/sectorspage/industry/industry (4).jpg";
import industry5 from "../assets/sectorspage/industry/industry (5).jpg";
import industry6 from "../assets/sectorspage/industry/industry (6).jpg";
import industry7 from "../assets/sectorspage/industry/industry (7).jpg";
import industry8 from "../assets/sectorspage/industry/industry (8).jpg";
import industry9 from "../assets/sectorspage/industry/industry (9).jpg";

import construction1 from "../assets/sectorspage/construction/construction (1).jpg";
import construction2 from "../assets/sectorspage/construction/construction (2).jpg";
import construction3 from "../assets/sectorspage/construction/construction (3).jpg";
import construction4 from "../assets/sectorspage/construction/construction (4).jpg";
import construction5 from "../assets/sectorspage/construction/construction (5).jpg";
import construction6 from "../assets/sectorspage/construction/construction (6).jpg";
import construction7 from "../assets/sectorspage/construction/construction (7).jpg";
import construction8 from "../assets/sectorspage/construction/construction (8).jpg";
import construction9 from "../assets/sectorspage/construction/construction (1).png";

import technology1 from "../assets/sectorspage/technology/technology (1).jpg";
import technology2 from "../assets/sectorspage/technology/technology (2).jpg";
import technology3 from "../assets/sectorspage/technology/technology (3).jpg";
import technology4 from "../assets/sectorspage/technology/technology (4).jpg";
import technology5 from "../assets/sectorspage/technology/technology (5).jpg";
import technology6 from "../assets/sectorspage/technology/technology (6).jpg";
import technology7 from "../assets/sectorspage/technology/technology (7).jpg";
import technology8 from "../assets/sectorspage/technology/technology (8).jpg";
import technology9 from "../assets/sectorspage/technology/technology (9).jpg";

import services1 from "../assets/sectorspage/services/services (1).jpg";
import services2 from "../assets/sectorspage/services/services (2).jpg";
import services3 from "../assets/sectorspage/services/services (3).jpg";
import services4 from "../assets/sectorspage/services/services (4).jpg";
import services5 from "../assets/sectorspage/services/services (5).jpg";
import services6 from "../assets/sectorspage/services/services (1).png";
import services7 from "../assets/sectorspage/services/services (2).png";
import services8 from "../assets/sectorspage/services/services (3).png";
import services9 from "../assets/sectorspage/services/services (4).png";

import charity1 from "../assets/sectorspage/charity/charity (1).jpg";
import charity2 from "../assets/sectorspage/charity/charity (2).jpg";
import charity3 from "../assets/sectorspage/charity/charity (3).jpg";
import charity4 from "../assets/sectorspage/charity/charity (4).jpg";
import charity5 from "../assets/sectorspage/charity/charity (5).jpg";
import charity6 from "../assets/sectorspage/charity/charity (2).png";
import charity7 from "../assets/sectorspage/charity/charity (7).jpg";
import charity8 from "../assets/sectorspage/charity/charity (8).jpg";
import charity9 from "../assets/sectorspage/charity/charity (1).png";

const sectorImages = {
  ecommerce: [commerce1, commerce2, commerce3, commerce4, commerce5, commerce6, commerce7, commerce8, commerce9],
  academy: [academy1, academy2, academy3, academy4, academy5, academy6, academy7, academy8, academy9],
  consultancy: [consultancy1, consultancy2, consultancy3, consultancy4, consultancy5, consultancy6, consultancy7, consultancy8, consultancy9],
  economy: [economy1, economy2, economy3, economy4, economy5, economy6, economy7, economy8, economy9],
  industry: [industry1, industry2, industry3, industry4, industry5, industry6, industry7, industry8, industry9],
  construction: [construction1, construction2, construction3, construction4, construction5, construction6, construction7, construction8, construction9],
  technology: [technology1, technology2, technology3, technology4, technology5, technology6, technology7, technology8, technology9],
  services: [services1, services2, services3, services4, services5, services6, services7, services8, services9],
  charity: [charity1, charity2, charity3, charity4, charity5, charity6, charity7, charity8, charity9],
};

const sectorData = {
  ecommerce: {
    id: "ecommerce",
    title: "ADAM STORE",
    description:
      "ADAM Store is a platform leading the digital transformation of commerce. With advanced technologies and innovative solutions, it provides a reliable, fast and effective commerce experience to its business partners and customers.",
    color: "#00578e",
    services: [
      { name: "Construction Materials", description: "Supplying high quality building materials for the construction industry, ADAM sets industry standards by offering durable and innovative solutions." },
      { name: "Metal & Mineral & Scrap", description: "It is a reliable partner in the industry with a wide supply chain network in the field of metals, minerals and recycling materials." },
      { name: "Electronics & Appliances", description: "It offers competitive solutions in the global market with state-of-the-art products in the electronics and white goods industry." },
      { name: "Textile & Threads", description: "It develops sustainable and innovative solutions with quality production processes in the textile and yarn industry." },
      { name: "Food & Medicine", description: "It contributes to public health by offering products that comply with hygiene and quality standards in the food and pharmaceutical sectors." },
      { name: "Auto Parts & Accessories", description: "It offers quality and reliable solutions in the supply of spare parts and accessories for the automotive industry." },
      { name: "Agriculture Machines", description: "Carries the agricultural sector forward with modern agricultural machinery and equipment." },
      { name: "Computers / Mobiles & Devices", description: "Offers state-of-the-art solutions for computers, mobile devices and accessories." },
      { name: "Fertilizers & Pesticides", description: "It supports sustainable agriculture by offering fertilizer and pesticide solutions that increase productivity in agriculture." },
    ],
  },

  academy: {
    id: "academy",
    title: "ADAM INTERNATIONAL ACADEMY",
    description:
      "ADAM international Academy is an education and research center that aims for excellence in education. It contributes to the academic and professional development of individuals by offering modern learning techniques and innovative approaches.",
    color: "#2c89a0",
    services: [
      { name: "Distance Learning & Online Study", description: "Provides education accessible worldwide with distance learning solutions." },
      { name: "Virtual Education", description: "Provides an interactive learning experience through innovative virtual education methods." },
      { name: "Research & Studies Center", description: "Provides support for scientific research and academic studies." },
      { name: "Student Healthcare & Gym", description: "Provides services that support students' health and physical activity." },
      { name: "Enrollment & Admission", description: "Guides students through streamlined application and admission processes." },
      { name: "Technical Support", description: "Provides technical support services during training processes." },
      { name: "Training & Coaching Center", description: "Offers specialized training and coaching programs for professional development." },
      { name: "Language & Translation Center", description: "Strengthens global communication through language training and translation services." },
      { name: "Career Counselling", description: "Offers career planning and counseling services." },
    ],
  },

  consultancy: {
    id: "consultancy",
    title: "ADAM SOLUTIONS",
    description:
      "ADAM Solutions provides professional consulting services in various sectors, helping businesses to increase their efficiency and achieve their strategic goals.",
    color: "#003f6b",
    services: [
      { name: "Engineering Consultancy", description: "Provides expert consultancy services in engineering projects." },
      { name: "Management Consultancy", description: "Provides guidance on business management and strategic planning." },
      { name: "Healthcare Consultancy", description: "Provides analysis and consulting services for the healthcare industry." },
      { name: "Environmental Consultancy", description: "Provides expert support for environmental sustainability and green projects." },
      { name: "Educational Consultancy", description: "Provides strategic planning and development solutions for educational institutions." },
      { name: "Technical Consultancy", description: "Provides consultancy services in areas requiring technical expertise." },
      { name: "Legal & Arbitration Consultancy", description: "Provides legal consultancy and mediation services." },
      { name: "Marketing Consultancy", description: "Provides guidance on marketing strategies and brand management." },
      { name: "Economic Consultancy", description: "Provides economic analysis and investment advisory services." },
    ],
  },

  economy: {
    id: "economy",
    title: "ADAM BANK",
    description:
      "ADAM Bank supports sustainable growth in the business world by providing innovative solutions in trade, investment and finance.",
    color: "#00a8cc",
    services: [
      { name: "Export & Import", description: "Provides reliable export and import services for international trade." },
      { name: "Trading & Purchases", description: "Provides trading solutions in global markets." },
      { name: "Wealth Management", description: "Offers financial asset management and investment advice." },
      { name: "Contracting", description: "Provides contract business management and project development services." },
      { name: "Agencies & Representation", description: "Provides brand representation and partnership solutions." },
      { name: "Financing & Banking", description: "Provides reliable services in financing and banking." },
      { name: "Marketing & Distributing", description: "Supports commercial activities with marketing and distribution strategies." },
      { name: "Shipping & Logistics & Transportation", description: "Provides international logistics and transportation solutions." },
      { name: "Procurement & Supplying", description: "Provides supply chain management and procurement services." },
    ],
  },

  industry: {
    id: "industry",
    title: "ADAM INDUSTRIES",
    description:
      "Adam Industry aims to provide high quality products and services in the global market by offering modern manufacturing and industrial solutions.",
    color: "#00578e",
    services: [
      { name: "Production Lines", description: "Provides efficient and high capacity production processes with advanced production lines." },
      { name: "Factories & Workshops", description: "Provides large-scale production solutions with industrial production and processing facilities." },
      { name: "Plastics Industries", description: "Produces durable and innovative products with plastic raw materials and processing technologies." },
      { name: "Textile Industries", description: "Prioritizes quality and sustainability by using the latest technology in textile production." },
      { name: "Food Industries", description: "Combines hygiene, quality and innovation in food production." },
      { name: "Electronics Industries", description: "Provides innovative manufacturing and assembly solutions for the electronics industry." },
      { name: "Oil & Gas Industries", description: "Provides refining and production services for the oil and gas industry." },
      { name: "Energy Industries", description: "Provides sustainable solutions in renewable and conventional energy production." },
      { name: "Mining Industries", description: "Conducts safe and efficient extraction, processing and supply processes in mining." },
    ],
  },

  construction: {
    id: "construction",
    title: "ADAM EPCM",
    description:
      "Adam EPCM is a leading developer of engineering, construction and infrastructure projects on a global scale.",
    color: "#2c89a0",
    services: [
      { name: "Steel Structure Construction", description: "Builds steel structures with high durability." },
      { name: "Concrete Building", description: "Provides modern and safe solutions in reinforced concrete building construction." },
      { name: "Railways Construction", description: "Develops engineering and infrastructure solutions in railway construction." },
      { name: "Airports Construction", description: "Provides innovative and functional designs for airport projects." },
      { name: "Infrastructure", description: "Provides expert solutions in road, bridge, dam and other infrastructure projects." },
      { name: "Shipbuilding", description: "Realizes projects in accordance with engineering and production standards in shipbuilding." },
      { name: "Wood Construction", description: "Provides sustainable and aesthetic solutions with wood construction technologies." },
      { name: "Tanks Construction", description: "Implements high safety standards in industrial and military tank construction." },
      { name: "Pre-Fabricated Buildings", description: "Develops fast and economical building projects with modular and prefabricated building solutions." },
    ],
  },

  technology: {
    id: "technology",
    title: "ADAM INNOVATION",
    description:
      "Adam Innovation is a technology leader that drives innovation by providing digital transformation and advanced technology solutions.",
    color: "#003f6b",
    services: [
      { name: "Communication Technology", description: "Provides communication infrastructures and telecommunication solutions." },
      { name: "Automation Technology", description: "Increases productivity by automating industrial and commercial processes." },
      { name: "Systems Software Technology", description: "Develops enterprise and individual software systems." },
      { name: "Healthcare Technology", description: "Provides digital solutions and medical device technologies for the healthcare industry." },
      { name: "Energy & Mining Technology", description: "Develops innovative technologies in the energy and mining industries." },
      { name: "Electronics & Security Technology", description: "Provides smart solutions in security and electronic systems." },
      { name: "Artificial Intelligence Technology", description: "Provides artificial intelligence-powered software and automation solutions." },
      { name: "Financial Technology", description: "Develops digital payment and blockchain solutions for the financial industry." },
      { name: "Information Technology", description: "Provides IT infrastructures, data security and software solutions." },
    ],
  },

  services: {
    id: "services",
    title: "ADAM ALLIANCE",
    description:
      "Adam Alliance focuses on optimizing its clients' business processes by providing professional services for a wide range of industries.",
    color: "#00a8cc",
    services: [
      { name: "Software & Training Services", description: "Provides software development and corporate training services." },
      { name: "Consulting & Design Services", description: "Provides business process and corporate design consulting services." },
      { name: "Marketing & Event Planning & Delivery Services", description: "Provides marketing strategies and event management solutions." },
      { name: "Security & Insurance Services", description: "Provides security and insurance services and risk management solutions." },
      { name: "Medical & Health & Traveling Services", description: "Develops innovative solutions in medical tourism and medical services." },
      { name: "Real Estate & Public Relation Services", description: "Provides real estate management and public relations services." },
      { name: "Agriculture & Landscaping & Maintenance", description: "Provides environmentally friendly solutions in agriculture, landscaping and maintenance services." },
      { name: "Legal & Accounting & Manpower Supply Services", description: "Provides legal consulting, accounting and human resources services." },
      { name: "Industrial & Waste Management Services", description: "Provides industrial waste management and recycling solutions." },
    ],
  },

  charity: {
    id: "charity",
    title: "ADAM FOUNDATION",
    description:
      "ADAM Foundation extends a helping hand to people around the world through social responsibility projects.",
    color: "#00578e",
    services: [
      { name: "Environmental & Climate Change", description: "Develops environmental sustainability projects." },
      { name: "Healthcare & Housing & Clothing", description: "Provides health, housing and clothing assistance." },
      { name: "Communities & Ethical Care", description: "Runs projects that improve the well-being of communities." },
      { name: "Food & Drinking Water", description: "Provides food and clean water." },
      { name: "Disasters & Wars Victims Aid", description: "Provides humanitarian aid to victims of disasters and wars." },
      { name: "Well Drilling & Water Supply", description: "Carries out water well drilling and clean water supply projects." },
      { name: "Agriculture & Irrigation", description: "Develops projects that support agricultural production." },
      { name: "Electrical & Power Supply", description: "Provides sustainable solutions for electricity and energy supply." },
      { name: "Education & Training", description: "Offers programs that support education and professional development." },
    ],
  },
};

const SingleSectorPage = () => {
  const { sectorId } = useParams();
  const sector = sectorData[sectorId];

  if (!sector) {
    return (
      <div className="sector-not-found">
        <h1>Sector Not Found</h1>
        <p>The sector you're looking for doesn't exist.</p>
        <a href="/sectors" className="sector-back-button">View All Sectors</a>
      </div>
    );
  }

  // Get images for this sector
  const sectorImageArray = sectorImages[sectorId] || [];

  return (
    <div className="single-sector-page">
      {/* Hero Section */}
      <header className="sector-hero" style={{ background: `linear-gradient(135deg, ${sector.color}, ${sector.color}80)` }}>
        <div className="sector-hero-content">
          <h1 className="sector-hero-title">{sector.title}</h1>
          <p className="sector-hero-description">{sector.description}</p>
        </div>
      </header>

      {/* Sector Overview */}
      <section className="sector-overview">
        <div className="sector-overview-content">
          <h2 className="sector-overview-title">About {sector.title}</h2>
          <div className="sector-overview-text">
            <p>{sector.description}</p>
            <div className="sector-stats">
              <div className="sector-stat">
                <span className="sector-stat-number">9</span>
                <span className="sector-stat-label">Core Services</span>
              </div>
              <div className="sector-stat">
                <span className="sector-stat-number">30+</span>
                <span className="sector-stat-label">Years Experience</span>
              </div>
              <div className="sector-stat">
                <span className="sector-stat-number">Global</span>
                <span className="sector-stat-label">Reach</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="sector-services">
        <div className="sector-services-header">
          <h2 className="sector-services-title">{sector.title} Services</h2>
          <p className="sector-services-subtitle">
            Comprehensive solutions tailored to meet your specific business needs
          </p>
        </div>
        <div className="sector-services-grid">
          {sector.services.map((service, index) => (
            <div key={index} className="sector-service-card">
              <div className="sector-service-image-container">
                {sectorImageArray[index] && (
                  <img 
                    src={sectorImageArray[index]} 
                    alt={service.name}
                    className="sector-service-image"
                    loading="lazy"
                  />
                )}
                <div className="sector-service-number">{index + 1}</div>
              </div>
              <div className="sector-service-content">
                <h3 className="sector-service-name">{service.name}</h3>
                <p className="sector-service-description">{service.description}</p>
                <div className="sector-service-line" style={{ backgroundColor: sector.color }}></div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Gallery Section */}
      <section className="sector-gallery">
        <h2 className="sector-gallery-title">Our Work in {sector.title}</h2>
        <p className="sector-gallery-subtitle">
          A visual showcase of our projects and achievements in this sector
        </p>
        <div className="sector-gallery-grid">
          {sectorImageArray.slice(0, 8,).map((image, index) => (
            <div key={index} className="sector-gallery-item">
              <img 
                src={image} 
                alt={`${sector.title} project ${index + 1}`}
                className="sector-gallery-image"
                loading="lazy"
              />
              <div className="sector-gallery-overlay">
                <span className="sector-gallery-caption">Project {index + 1}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="sector-cta">
        <div className="sector-cta-content" style={{ backgroundColor: `${sector.color}20` }}>
          <h2 className="sector-cta-title">Ready to Partner with {sector.title}?</h2>
          <p className="sector-cta-text">
            Contact our experts to discuss how we can help you achieve your business goals.
          </p>
          <div className="sector-cta-buttons">
            <a href="/contact" className="sector-cta-button sector-cta-button--primary">
              Get in Touch
            </a>
            <a href="/sectors" className="sector-cta-button sector-cta-button--secondary">
              View All Sectors
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SingleSectorPage;